function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 34.78,
  cy: 38.597,
  r: 10.994
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  stroke: "#000000",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 34.78,
  y1: 15.408,
  x2: 34.78,
  y2: 20.046
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  stroke: "#000000",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 18.383,
  y1: 22.2,
  x2: 21.66,
  y2: 25.48
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  stroke: "#000000",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 11.591,
  y1: 38.597,
  x2: 16.229,
  y2: 38.597
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  stroke: "#000000",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 18.383,
  y1: 54.994,
  x2: 21.663,
  y2: 51.715
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  stroke: "#000000",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 34.78,
  y1: 61.787,
  x2: 34.78,
  y2: 57.147
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  stroke: "#000000",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 51.177,
  y1: 54.994,
  x2: 47.896,
  y2: 51.715
});

var _ref9 = /*#__PURE__*/React.createElement("line", {
  stroke: "#000000",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 57.969,
  y1: 38.598,
  x2: 53.331,
  y2: 38.598
});

var _ref10 = /*#__PURE__*/React.createElement("line", {
  stroke: "#000000",
  strokeWidth: 5,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  x1: 51.177,
  y1: 22.2,
  x2: 47.896,
  y2: 25.48
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M76.274,83.335c-6.798,1.599-13.602-0.716-18.055-5.474c3.045,0.909,6.361,1.063,9.678,0.286  c10.116-2.379,16.389-12.51,14.01-22.625c-0.78-3.317-2.396-6.215-4.567-8.537c6.244,1.867,11.348,6.924,12.947,13.725  C92.664,70.827,86.392,80.956,76.274,83.335z"
});

var SvgDaynight = function SvgDaynight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDaynight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/daynight.576a8c46.svg";
export { ForwardRef as ReactComponent };